import { ChatStore } from "@/stores/ChatStore";
import { EUserInfoFormStatus } from "@/types";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AddressInput } from "./address-input";
import { InsuranceNumberInput } from "./insurance-number-input";
import { DateOfBirthInput } from "./date-of-birth-input";
import { UserInfoDialogFooter } from "./user-info-dialog-footer";

export default function UserInfoForm() {
  const { t } = useTranslation();
  const user = ChatStore(state => state.user);
  const userInfoFormStatus = ChatStore(state => state.userInfoFormStatus);
  const setUserInfoFormStatus = ChatStore(state => state.setUserInfoFormStatus);

  const onOpenChange = (open: boolean) => {
    window.alert("Aborted");
    setUserInfoFormStatus(open ? EUserInfoFormStatus.open : EUserInfoFormStatus.hidden);
  };
  if (!user || userInfoFormStatus !== EUserInfoFormStatus.open) {
    return null;
  }

  const getTitle = () => {
    return t(`userInfoForm.titleByStatus.${user.claimStatus}`) || t("userInfoForm.title");
  };

  return (
    <Dialog open={userInfoFormStatus === EUserInfoFormStatus.open} onOpenChange={onOpenChange}>
      <DialogContent>        <DialogHeader>
          <DialogTitle>
            {getTitle()}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2 pb-4">
          <AddressInput />
          <InsuranceNumberInput />
          <DateOfBirthInput />
        </div>
        <UserInfoDialogFooter onOpenChange={onOpenChange} />
      </DialogContent>
    </Dialog>
  );
}